interface Ending {
	1: string
	2: string
	5: string
}

export const wordEnding = (number: number, ending: Ending): string => {
	number = Math.floor(Math.abs(number))

	const lastTwoDigitsNumber: number = +number.toString().slice(-2)
	if (lastTwoDigitsNumber >= 5 && lastTwoDigitsNumber <= 20) {
		return ending['5']
	}

	const lastOneDigitNumber: number = +number.toString().slice(-1)
	if (lastOneDigitNumber === 1) {
		return ending['1']
	}

	if (lastOneDigitNumber >= 2 && lastOneDigitNumber <= 4) {
		return ending['2']
	}

	return ending['5']
}
